import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { ui } from '@/constants';

@Component({
  name: 'CmgMaxEntreeLimitModal',
})
export default class CmgMaxEntreeLimitModal extends Vue {

  get visible(): boolean {
    return this.$appStore.state.ui.modals.maxEntreeLimitModal.visible;
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }

  get maxEntreeLimitNumber(): string | undefined {
    return this.$appStore.state.ui.modals.maxEntreeLimitModal.args?.maxEntreeLimitNumber;
  }

  close() {
    this.$services.ui.setModalVisibility('maxEntreeLimitModal', false);
    Vue.nextTick(() => {
      setTimeout(() => {
        this.$services.ui.focusBack();
      }, 1000);
    });
  }

  goToBag() {
    this.$services.bag.setBagVisibility(true);
    this.close();
  }

  onClickCatering() {
    window.open(this.$services.config.getCateringUrl(), '_blank');
    this.close();
  }
}
